var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tsName"},[_c('section',[_vm._v(_vm._s(_vm.reasonData.ShowReason))]),_vm._v(" "),(_vm.reasonData.Comment)?_c('div',{staticClass:"allTsName"},[_vm._v(_vm._s(_vm.reasonData.Comment))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d601f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myComponents/showReason.vue
// module id = null
// module chunks = 